document.addEventListener('DOMContentLoaded', function () {
  const submitBtn = document.querySelector('.js-contact-button-submit');

  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      const order = document.querySelector('.js-contact-order-number')?.value?.trim();
      const messageBox = document.querySelector('.js-contact-body');

      if (messageBox) {
        let prependText = '';
        if (order) prependText += 'Order number: ' + order + '\n';
        if (prependText) {
          messageBox.value = prependText + '\n' + messageBox.value;
        }
      }
    });
  }
});